import LocalizedClientLink from '@modules/common/components/localized-client-link';

const ConsentTab = () => (
  <div className="flex flex-col gap-2">
    <p className="font-body font-bold text-base leading-[1.5] text-brand-neutral-900">
      This website uses cookies
    </p>
    <p className="font-body text-sm leading-[1.5] text-brand-neutral-900">
      We use cookies and similar technologies to personalise content and ads, to
      provide social media features and to analyse our traffic. We also share
      information about your use of our site, which may include health data,
      with our social media, advertising and analytics partners who may combine
      it with other information that you&apos;ve provided to them or that
      they&apos;ve collected from your use of their services. See our full{' '}
      <LocalizedClientLink
        href="/cookie-policy"
        prefetch={false}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Cookie Policy (opens in a new tab)"
        className="font-bold underline decoration-solid text-brand-neutral-900 hover:no-underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-neutral-900"
      >
        Cookie Policy
      </LocalizedClientLink>
      .
    </p>
  </div>
);

export default ConsentTab;
